import Utils from "../../services/Utils.js";
import {} from "../../js/api/countries.js";
import { getCountries } from "../../js/api/countries.js";
import { getFeaturedMatches } from "../../js/api/featuredPreMatch.js";
import { _t } from "../../services/TranslationService.js";
import { getLeagues } from "../../js/api/leagues.js";

let Categories = {
  render: async () => {
    let request = Utils.parseRequestURL();
    const blockedSports = JSON.parse(
      localStorage.getItem("blockedSports") ?? "[]",
    );
    if (blockedSports.includes(request.id)) {
      window.location.href = "#/";
      return "";
    }
    let countries = await getCountries(request.id);
    countries = countries.filter((country) => country.id != 447);
    let countryView = "";
    let featuredPrematchView = "";
    let featuredPrematchs = await getFeaturedMatches(request.id);
    let sportName = countries[0].sport;
    let sportId = countries[0].sport_id;
    countries.forEach((country) => {
      // <a href="#/p/${post.id}">${post.title}</a>
      countryView =
        countryView +
        `<a class="countryListContentItem" href="#/league/${country.id}" data-id="${country.id}">${country.name}
        <svg width="20" height="20" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.1584 3.13508C6.35985 2.94621 6.67627 2.95642 6.86514 3.15788L10.6151 7.15788C10.7954 7.3502 10.7954 7.64949 10.6151 7.84182L6.86514 11.8418C6.67627 12.0433 6.35985 12.0535 6.1584 11.8646C5.95694 11.6757 5.94673 11.3593 6.1356 11.1579L9.565 7.49985L6.1356 3.84182C5.94673 3.64036 5.95694 3.32394 6.1584 3.13508Z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"></path></svg>
        </a>`;
    });

    if (request.id == 1) {
      featuredPrematchs.forEach((featuredPrematch) => {
        const date = new Date(featuredPrematch.game_date);
        let dd = String(date.getDate()).padStart(2, "0");
        let mm = String(date.getMonth() + 1).padStart(2, "0"); //January is 0!
        let yyyy = date.getFullYear();

        const time = `${featuredPrematch.game_time.split(":")[0]}:${featuredPrematch.game_time.split(":")[1]}`;
        if (featuredPrematch.odd) {
          featuredPrematchView =
            featuredPrematchView +
            `<div class="featuredPrematchItem">
                   <a href="#/Match/${featuredPrematch.id}" class="featuredMatchName">
                       <span>${featuredPrematch.home_team}</span>
                       <span>${featuredPrematch.away_team}</span>
                    </a>
                    <span class="featurePreMatchDate">${dd}/${mm} ${time}</span>
                        <span class="numberofmarkets">${featuredPrematch.count_options} ></span>
                    <div class="featuredMatchBtn">
                        <div class="singleHomeOdd bettingBtn ${Math.floor((parseFloat(featuredPrematch.odd.split(",")[0].split("|")[1]) + Number.EPSILON) * 100) / 100 == 1 ? "disabledBtn" : ""} ${featuredPrematch.odd.split(",")[0].split("|")[0]}" match-odd="${featuredPrematch.odd.split(",")[0].split("|")[1]}" match-home-name="${featuredPrematch.home_team}" match-away-name="${featuredPrematch.away_team}" match-market="${["1", "X", "2"].includes(featuredPrematch.odd.split(",")[0].split("|")[2]) ? "Rezultat final" : featuredPrematch.odd.split(",")[0].split("|")[2]}" match-market-option="1 " coef-id="${featuredPrematch.odd.split(",")[0].split("|")[0]}" bet-id="${featuredPrematch.odd.split(",")[0].split("|")[0]}" game-id="${featuredPrematch.id}"><i>1</i><i>${(Math.floor((parseFloat(featuredPrematch.odd.split(",")[0].split("|")[1]) + Number.EPSILON) * 100) / 100).toFixed(2)}</i></div>
                         <div class="singleDrawOdd bettingBtn ${Math.floor((parseFloat(featuredPrematch.odd.split(",")[1].split("|")[1]) + Number.EPSILON) * 100) / 100 == 1 ? "disabledBtn" : ""} ${featuredPrematch.odd.split(",")[1].split("|")[0]}" match-odd="${featuredPrematch.odd.split(",")[1].split("|")[1]}" match-home-name="${featuredPrematch.home_team}" match-away-name="${featuredPrematch.away_team}" match-market="${["1", "X", "2"].includes(featuredPrematch.odd.split(",")[1].split("|")[2]) ? "Rezultat final" : featuredPrematch.odd.split(",")[1].split("|")[2]}" match-market-option="X " coef-id="${featuredPrematch.odd.split(",")[1].split("|")[0]}" bet-id="${featuredPrematch.odd.split(",")[1].split("|")[0]}" game-id="${featuredPrematch.id}"><i>X</i><i>${(Math.floor((parseFloat(featuredPrematch.odd.split(",")[1].split("|")[1]) + Number.EPSILON) * 100) / 100).toFixed(2)}</i></div>
                         <div class="singleAwayOdd bettingBtn ${Math.floor((parseFloat(featuredPrematch.odd.split(",")[2].split("|")[1]) + Number.EPSILON) * 100) / 100 == 1 ? "disabledBtn" : ""} ${featuredPrematch.odd.split(",")[2].split("|")[0]}" match-odd="${featuredPrematch.odd.split(",")[2].split("|")[1]}" match-home-name="${featuredPrematch.home_team}" match-away-name="${featuredPrematch.away_team}" match-market="${["1", "X", "2"].includes(featuredPrematch.odd.split(",")[2].split("|")[2]) ? "Rezultat final" : featuredPrematch.odd.split(",")[2].split("|")[2]}" match-market-option="2 " coef-id="${featuredPrematch.odd.split(",")[2].split("|")[0]}" bet-id="${featuredPrematch.odd.split(",")[2].split("|")[0]}" game-id="${featuredPrematch.id}"><i>2</i><i>${(Math.floor((parseFloat(featuredPrematch.odd.split(",")[2].split("|")[1]) + Number.EPSILON) * 100) / 100).toFixed(2)}</i></div>
                    </div>
              </div>`;
        }
      });
    }

    let leagues = await getLeagues(447);

    let leagueView = "";
    leagues.forEach((league) => {
      // <a href="#/p/${post.id}">${post.title}</a>
      leagueView =
        leagueView +
        `<a class="leagueListContentItem" href="#/games/${league.id}" data-id="${league.id}">${league.name}</a>`;
    });

    let view = `
        <div class="pageHeaderTitle">
            <a class="backBtn">
                <svg width="25" height="25" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill="#939393" d="M8.84182 3.13514C9.04327 3.32401 9.05348 3.64042 8.86462 3.84188L5.43521 7.49991L8.86462 11.1579C9.05348 11.3594 9.04327 11.6758 8.84182 11.8647C8.64036 12.0535 8.32394 12.0433 8.13508 11.8419L4.38508 7.84188C4.20477 7.64955 4.20477 7.35027 4.38508 7.15794L8.13508 3.15794C8.32394 2.95648 8.64036 2.94628 8.84182 3.13514Z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"></path></svg>
            </a>
            <span>${_t(sportName)}</span>
            <a href="#/InPlay/${sportId}" class="liveTitleBtn">${_t("Live <i>InPlay</i>")}</a>
        </div>
        <div class="categoriesOutright" style="border-top: 1px solid #585858;">
            <a class="active">${_t("Kampionatet")}</a>
            ${sportId == 1 ? `<a>${_t("Outrights")}</a>` : ``}
        </div>
        <div class="accord active" id="champions">
            <div class="padding-boddy">
            ${
              request.id == 1
                ? ` 
                <div class="betModule liveInModule accordionDisable">
                    <div class="betModuleHeaderContainer"> 
                        <a class="betModuleHeaderBtn">
                            <span>${_t("Ndeshjet Kryesore")}</span>
                            <span class="yellowColored"></span>
                        </a>
                        <a class="betHeaderEventBtn" href="#/inPlay"></a>
                    </div>
                </div>
                <div class="featuredPrematchWrapper">
                    <div class="featuredPrematchSlider">
                        ${featuredPrematchView}
                    </div>            
                </div>
            `
                : ""
            }
            <div class="countryHeaderLabel">
                <span>${_t("Countries")}</span>
            </div>
            <div class="countryHeaderContent">
                ${countryView}
            </div>
            </div>
        </div>
        
        ${
          sportId == 1
            ? `
            <div class="accord" id="outrights">
                <div class="leagueHeaderLabel">
                    <span>${_t("Lista e kampioneve")}</span>
                </div>
                <div class="leagueHeaderContent">
                    ${leagueView}
                </div>
            </div>
            `
            : ``
        }
    `;

    return view;
  },
  after_render: async () => {
    // Toggle Champions / Outrights
    const tabs = document.querySelectorAll(".categoriesOutright a");
    const champions = document.getElementById("champions");
    const outrights = document.getElementById("outrights");

    tabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        tabs.forEach((t) => t.classList.remove("active"));
        tab.classList.add("active");

        const isOutrights = tab.textContent.toLowerCase().includes("outright");

        if (isOutrights) {
          champions.classList.remove("active");
          outrights?.classList.add("active");
        } else {
          champions.classList.add("active");
          outrights?.classList.remove("active");
        }
      });
    });

    $("body .featuredPrematchWrapper").each(function () {
      let featuredSliderWidth = 0;
      $(this)
        .children(".featuredPrematchSlider")
        .children(".featuredPrematchItem")
        .each(function () {
          featuredSliderWidth += $(this).outerWidth() + 3;
        });

      $(this)
        .children(".featuredPrematchSlider")
        .css({
          width: featuredSliderWidth - 3 + "px",
        });
    });
  },
};

export default Categories;
